import t, { memo as n } from "react";
import { Flex as p, Heading as s } from "@chakra-ui/react";
import "@chakra-ui/system";
import { getResponsiveTypography as f } from "../../../utils/typographyUtils.js";
const x = n(
  ({
    alignment: e,
    typography: o,
    responsiveTypography: r,
    headingTag: a = "h2",
    children: i,
    color: m
  }) => /* @__PURE__ */ t.createElement(p, { flex: "1", justifyContent: e }, /* @__PURE__ */ t.createElement(
    s,
    {
      as: a,
      "data-testid": "heading",
      textAlign: e.toLowerCase(),
      color: m,
      ...o ?? f(r)
    },
    i
  ))
);
export {
  x as Title
};
